// extracted by mini-css-extract-plugin
export default {"warn-icon":"src-components-common-UnsupportedMetric-index__warn-icon--NSkCP","warnIcon":"src-components-common-UnsupportedMetric-index__warn-icon--NSkCP"};